import './landing.less';
import React, {Proptypes} from 'react';
import { Link,browserHistory } from 'react-router';
import Header from '../header/header';
import Footer from '../footer/footer';
// import TabLayout from '../components/tab_layout/tab_layout';
import Slider from 'react-slick';
import {shipper, slides, ShippingRoleData} from './landing_data';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import MediaQuery from 'react-responsive';
// import {changeLocale, i18nEventsListenerMixin, setupI18NConfiguration, i18n } from "react-i18n-helper";

class HeroContent extends React.Component{
  constructor(props) {
    super(props);
    this.scrollToShippingRole = this.scrollToShippingRole.bind(this);
    this.goToSignUpPage = this.goToSignUpPage.bind(this);
  }

  goToSignUpPage(){
    browserHistory.push('/signup');
  }

  scrollToShippingRole(){
      const headerPadding = parseInt($("header").css('padding-bottom').match(/\d+/)[0]) + parseInt($("header").css('padding-top').match(/\d+/)[0]);  //remove px from the padding
      $('html, body').animate({
                                scrollTop: $("#shipping-role-section").offset().top - $("header").height() -  headerPadding
                              }, 1000);
      //shipping role section id offset - top header height - padding of the header (20px)
  }


  render(){

    return(
        <div className = "full-page-section" id = "hero-section">
          <div className = "wrapper">
            <div className = "hero-section-content-wrap">
              <h2 className = "hero-title">The revolution of shipping is here</h2>
              <p className = "hero-subtitle">Ship your packages locally or internationally with trusted carriers for the lowest price.</p>
              {/*
              <div className = "hero-btns-wrp">
                  <div className = "button-wrap landing-btn">
                    <button className = "btn orange" onClick={this.goToSignUpPage}>Ship a Package</button>
                  </div>
                  <div className = "img-wrap">
                    <img className = "lock-img" src="public/images/landing/lock.png" />
                  </div>
                  <div className = "button-wrap landing-btn">
                    <button className = "btn green" onClick={this.goToSignUpPage}>Carry a Package</button>
                  </div>
                  </div>
              */}
              <div className = "button-wrap landing-btn">
                  <button className = "btn orange" onClick={this.goToSignUpPage}>Sign Up Now</button>
              </div>
            </div>
            <div className = "learn-more-wrap">
              <span className="icon-down-arrow-outline icon-load-more" onClick={this.scrollToShippingRole}></span>
              <div className = "learn-more">Learn more</div>
            </div>
          </div>
        </div>
    )
  }
}

class ShippingRole extends React.Component{
  constructor(props) {
    super(props);
    this.goToSignUpPage = this.goToSignUpPage.bind();
    this.scrollToShipPackage = this.scrollToShipPackage.bind(this);
    this.scrollToCarryPackage = this.scrollToCarryPackage.bind(this);
    this.scrollToRequestPackage = this.scrollToRequestPackage.bind(this);
  }

  goToSignUpPage(){
    browserHistory.push('/signup');
  }

  scrollToShipPackage(){

    const headerPadding = parseInt($("header").css('padding-bottom').match(/\d+/)[0]) + parseInt($("header").css('padding-top').match(/\d+/)[0]) ;  //remove px from the padding
    $('html, body').animate({
                              scrollTop: $(".shipping-role-detail-section").offset().top - $("header").height() -  headerPadding
                            }, 1000);
    //shipping role section id offset - top header height - padding of the header (20px)
  }

  scrollToCarryPackage(){

    const headerPadding = parseInt($("header").css('padding-bottom').match(/\d+/)[0]) + parseInt($("header").css('padding-top').match(/\d+/)[0]) ;  //remove px from the padding
    $('html, body').animate({
                              scrollTop: $(".shipping-role-detail-section").offset().top + $("#shipping-role-detail-section").height()
                            }, 1000);
    //shipping role section id offset - top header height - padding of the header (20px)
  }

  scrollToRequestPackage(){

      const headerPadding = parseInt($("header").css('padding-bottom').match(/\d+/)[0]) + parseInt($("header").css('padding-top').match(/\d+/)[0]) ;  //remove px from the padding
      $('html, body').animate({
                                scrollTop: $(".recieving-section").offset().top -  headerPadding - $("header").height()
                              }, 1000);
      //shipping role section id offset - top header height - padding of the header (20px)
  }

  render(){
      return(
        <div id = "shipping-role-section">
          <div className = "wrapper">
            <div className = "shipping-role-content-wrap">
              <div className = "ship-a-package-wrap" onClick={this.scrollToShipPackage}>
                <div className = "ship-a-package-img"></div>
                <h2 className = "shipping-role-title">Ship a Package</h2>
                <p className = "shipping-role-info">Ship packages locally or internationally. All shipments are 100% guaranteed and insured.</p>
              </div>
              {/*
                <div className = "previous-img"></div>
                <div className = "next-img"></div>
              */}
              <div className = "carry-a-package-wrap"  onClick={this.scrollToCarryPackage}>
                <div className = "carry-a-package-img"></div>
                <h2 className = "shipping-role-title">Carry a Package</h2>
                <p className = "shipping-role-info">Make some extra dough while you travel. Easy coordination for pickup and delivery.</p>
              </div>

              <div className = "request-an-item-wrap" onClick={this.scrollToRequestPackage}>
                <div className = "request-a-package-img"></div>
                <h2 className = "shipping-role-title">Request an Item</h2>
                <p className = "shipping-role-info">Want to buy something available in another city? Request a carrier to buy and bring it for you.</p>
              </div>
            </div>
          </div>
        </div>
      )
  }
}

class HowItWorkCarousel extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      carousel: {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000
      }
    }
  }

  render(){
    const {props, state} = this;
    const imgURL = "public/images/landing/quotes.png";
    return(
      <div id = "how-it-work-section">
        <div className = "wrapper">
          <div className = "how-it-work-content-wrap">
            <MediaQuery query='(min-width: 768px)' > <div className="qoutes-img" style={{
            "backgroundImage": 'url("' + imgURL + '")'}}></div></MediaQuery>
            <Slider {...state.carousel}>
              {
                slides.map((slide, key) => {
                  return(
                    <div className = "slide-content-wrap" key={key}>
                      <h2 className = "slide-title">{slide.title}</h2>
                      <div className = "slide-info-wrap">
                        {/*
                        <div className = "slide-img-wrap">
                          <img src = {slide.imgSrc} className = "slide-image" />
                        </div>
                        */}
                        <div className = "slide-content">
                          <p className = "slide-info">{slide.content}</p>
                          <div className = "slide-subtitle">{slide.subtitle}</div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </Slider>
          </div>
        </div>
      </div>
    )
  }
}

class GetShipping extends React.Component{

  constructor(props){
    super(props);
  }

  render(){
    return(
      <div id = "get-shipping-section">
        <div className = "wrapper">
          <div className = "get-shipping-content-wrap">
            <h1 className = "get-shipping-title">Get Shipping!</h1>
            <p className = "get-shipping-info">Are you ready to get things moving? Sign up now to post your shipment and pick up items to deliver</p>
            <div className = "get-shipping-btn-wrap">
              <Link to="/signup">
                <button className = "btn orange">Sign Up Now</button>
              </Link>
            </div>
            <MediaQuery query='(max-width: 767px)'>
              <div className = "button-wrap download-btns-wrap">
                <a className="link" target="_blank" href="http://play.google.com/store/apps/details?id=com.awb.android">
                  <img className="playstore-img" src="../public/images/landing/playstore.png"/>
                </a>
                <a className="link" target="_blank" href="https://itunes.apple.com/us/app/airwaybill/id1198529029?ls=1&mt=8">
                  <img className="appstore-img" src="../public/images/landing/appstore.png"/>
                </a>
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    )
  }
}

class ShippingRoleDetail extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      carousel: {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 2000
      }
    }
  }
  render(){
    const {props,state} = this;
    const {shipmentRole} = props;
    let scrollClassName = props.scrollClassName + " " + "shipping-role-detail-section";
    return(
      <div id = "shipping-role-detail-section" className ={scrollClassName}>
        <div className = "wrapper">
          <div className = "shipping-role-detail-wrap">
            <div className = "shipping-role-detail">
              <h2 className = "shipping-role-title">{shipmentRole.title}</h2>
              <MediaQuery query='(min-width: 768px)'>
                <div className = "shipping-role-info-wrp">
                  {
                    shipmentRole.roles.map((role,key)=>{
                      return(
                        <div key={key}>
                            <div className = "shipping-role-info">
                              <h4 className = "shipping-role">{role.role}</h4>
                              <div className = "shipping-role-content">{role.info}</div>
                            </div>
                        </div>
                      )
                    })
                  }
                </div>
              </MediaQuery>
              <MediaQuery query='(max-width: 767px)'>
                <div className = "shipping-role-info-wrp">
                  <Slider {...state.carousel}>
                    {
                      shipmentRole.roles.map((role,key) => {
                        return(
                          <div key={key}>
                              <div className = "shipping-role-info">
                                <h4 className = "shipping-role">{role.role}</h4>
                                <div className = "shipping-role-content">{role.info}</div>
                              </div>
                          </div>
                        )
                      })
                    }
                  </Slider>
                </div>
              </MediaQuery>
            </div>
            {/*<MediaQuery query='(min-width: 768px)'>
              <div className = "shipping-role-img" style={{"backgroundImage": 'url("' + shipmentRole.imageUrl + '")'}}></div>
            </MediaQuery> */}
          {/*  <MediaQuery query='(max-width: 767px)'>
              <div className = "shipping-role-img" style={{"backgroundImage": 'url("' + shipmentRole.imageUrlResponsive + '")'}}></div>
            </MediaQuery> */}
            {<div className = "shipping-role-img" style={{"backgroundImage": 'url("' + shipmentRole.imageUrl + '")'}}></div>}
          </div>
        </div>
      </div>
    )
  }
}

ShippingRoleDetail.propTypes = {
  scrollClassName: React.PropTypes.string.isRequired
}

export default class Landing extends React.Component{

  constructor(props){
    super(props);
    {/*
      const initialData = {"HelloWorld" : "Hello, World!"};
      this.changeLanguage = this.changeLanguage.bind(this);
      setupI18NConfiguration({clientPath : "../app/i18n", fallBackLocale : "en", initialState : {"locale" : "en", data : initialData}});
    */}
  }

  // changeLanguage(lang,name){
  //   changeLocale(lang);
  //   this.setState({'lang':lang});
  // }

  render(){
    const {props, state} = this;

    return(
      <div className="page-landing">

          {/*
          <div>
            <button onClick={this.changeLanguage.bind('pt','pt')}>pt</button>
            <button onClick={this.changeLanguage.bind('en','en')}>en</button>
            <button onClick={this.changeLanguage.bind('fr','fr')}>fr (Will falback to en-GB)</button>
          </div>
          <h2>{i18n("HelloWorld")}</h2>
          */}


        <Header isFixedHeader={true} />
        <HeroContent />
        <ShippingRole />
        {/*
          <TabLayout shipperObj = {shipper.shipperObjPost} flyerObj = {shipper.flyerObjGet} />
          <TabLayout shipperObj = {shipper.shipperObjShip} flyerObj = {shipper.flyerObjTrack} />
          <TabLayout shipperObj = {shipper.shipperObjDeliver} flyerObj = {shipper.flyerObjReview} />
        */}
        <ShippingRoleDetail shipmentRole={ShippingRoleData.shipper} scrollClassName={'shipping-section'} />
        <ShippingRoleDetail shipmentRole={ShippingRoleData.carrier} scrollClassName={'carrying-section'}/>
        <ShippingRoleDetail shipmentRole={ShippingRoleData.receiver} scrollClassName={'recieving-section'}/>
        <HowItWorkCarousel />
        <GetShipping />
        <Footer />
      </div>
    )
  }
}

Landing.propTypes = {
};



// WEBPACK FOOTER //
// app/landing/landing.jsx